import { withTranslation } from "react-i18next";

import React from 'react';
import { Footer } from '../Common/Footer';
import { Link } from 'react-router-dom';
import { DashboardHeader } from '../Common/DashboardHeader';
import Request from '../../Models/Request';
import SimpleReactValidator from 'simple-react-validator';
import axios from 'axios';
import { Header } from '../Common';
import { SideBar } from '../Common/SideBar';
class RequestDetailsConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            categories: [],
            subCategories: [],
            category: '',
            sub_cat: '',
            request: '',
            requestAll: [],
            response_content: '',
            seller: '',
            date: '',
            budget: '',
            count: '',
            existing: '',
            visible: false
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        console.log(this.props.location)
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    componentWillMount() {
        Request.getRequestDetail(this.props.location.state.id, this.props.location.state.user).then(res => {
            console.log(res.data)
            if (res.data.payload != null) {
                this.setState({ request: res.data.payload })
                this.setState({ requestAll: res.data.requestall })
                this.setState({ count: res.data.count })
                this.setState({ existing: res.data.existing_response })
            }
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.props.location.state.response_content == '' || this.props.location.state.response_content == null) {
                alert(this.props.t('0'));
                return;
            } else if (this.props.location.state.budget == '' || this.props.location.state.budget == null) {
                alert(this.props.t('3'));
                return;
            } else if (this.props.location.state.date == '' || this.props.location.state.date == null) {
                alert(this.props.t('4'));
                return;
            }
            let data = {
                'request_id': this.state.request.id,
                'seller_id': logged_user.id,
                'content': this.props.location.state.response_content,
                'estimated_price': this.props.location.state.budget,
                'estimated_deadline': this.props.location.state.date,
            }
            Request.saveRequestDetail(data).then(res => {
                if (res.data.status === 200) {
                    alert(this.props.t('1'))
                    console.log(res.data)
                    if (res.data.path === 'TRANSACTION') {
                        this.props.history.push( '/seller-estimate')
                    } else {
                        this.props.history.push( '/request-home')
                    }
                }
            })
                .catch(
                    console.log('asd')
                )
        } else {
            // this.validator.showMessages();
        }
    }
    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container">
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-4 input_name">
                                <SideBar />
                            </div>
                            <div className="col-md-8">
                                <div className="request">
                                    <div className="blank_div"></div>
                                    <div className="mini_padding" style={{ height: "auto" }}>
                                        <div className="row  px-3">
                                            <div className="mini_padding inner-div" style={{ width: "100%", minHeight: "370px" }}>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-2" style={{ textAlign: "center" }}>
                                                        <img style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                        </div>
                                                    <div className="col-md-10">
                                                        <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.state.request.buyer_name}</span></div>
                                                        <div style={{ fontSize: "22px" }}><b>{this.state.request.title}</b></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-7">
                                                        <div style={{ fontSize: "11px" }}><span style={{ color: "#37c9dc" }}>{this.props.t('5')} : </span> {this.state.request.cat}</div>
                                                        <div style={{ fontSize: "11px" }}>
                                                            <span style={{ color: "#37c9dc" }}>{this.props.t('6')} : </span> {this.state.request.application_date}&nbsp;
                                                                <span style={{ color: "#37c9dc" }}>{this.props.t('10')} : </span> {this.state.request.budget_range} {this.props.t('11')}
                                                            </div>
                                                    </div>
                                                    <div className="col-md-3">
                                                    </div>
                                                </div>
                                                <div className="col-md-12 row">&nbsp;</div>
                                                <div className="col-md-12 row">
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-10">
                                                        {this.state.request.content}<br /><br />
                                                        {/* ※ {this.props.t('2')}. */}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="mini_padding inner-div" style={{ width: "100%", height: "auto" }}>
                                                <div style={{ border: '1px solid #ccc' }}>
                                                    <div id="floating_div" className="mini_padding inner-div" style={{ width: "100%", height: 'auto', display: "block", textAlign: "center" }}>
                                                        <div className="row ml-3" >
                                                            <div className="col-md-8">
                                                                <div className="row">
                                                                    <img style={{ borderRadius: "50%", height: "60px" }} src={this.state.request.img} alt=""></img>&nbsp;&nbsp;
                                                                    <div className="ml-5 mt-3">{this.state.request.buyer_name}</div>
                                                                </div>
                                                                <div className="mt-3">
                                                                    {this.props.location.state.response_content}
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div>
                                                                    <h4>{this.props.location.state.budget}</h4>
                                                                </div>
                                                                <div>
                                                                    <div>
                                                                        {this.props.t('6')}
                                                                    </div>
                                                                    <div>
                                                                        {this.props.location.state.date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{ width: '100%' }}>

                                                <div className="request_confirm_button ">
                                                    <div className="row">
                                                        <div className="col-md-6 text-right">
                                                            <Link to={{
                                                                pathname: `/request-details/${this.props.location.state.id}`,
                                                                state: {
                                                                    user: this.props.location.state.user,
                                                                    id: this.props.location.state.id,
                                                                    response_content: this.props.location.state.response_content,
                                                                    date: this.props.location.state.date,
                                                                    budget: this.props.location.state.budget
                                                                }
                                                            }}>
                                                                <button className="request_confirm_edit " ><h5>{this.props.t('8')}</h5></button>
                                                            </Link>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <button type="submit" className="btn  request_confirm_edit" style={{ backgroundColor: "#7ea9e6",borderColor: "#6290d1",color:'#fff',boxShadow:"#ffffff4d 0px 1px 0px 0px inset" }} onClick={this.handleSubmit.bind(this)}>{this.props.t('9')}</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    &nbsp;&nbsp;
            </div>
                <Footer />
            </div >
        )
    }
}
export { RequestDetailsConfirmation }


 RequestDetailsConfirmation = withTranslation('src_Components_Request_RequestDetailsConfirmation')(RequestDetailsConfirmation);